import React from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import {
    Breadcrumb,
    Col,
    Row,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import locale from "locale";

import ManageOpenPollResult from "./ManageOpenPollResult";

const templates = {
    open: (props) => <ManageOpenPollResult {...props} />,
}

const ManagePollResultPage = ({ event }) => {
    const { pollType, pollId } = useParams();

    if (!templates[pollType]) return <>Не существует опроса такого типа</>;

    return (
        <section>
            <Row>
                <Col xs={6}>
                    <Breadcrumb>
                        <LinkContainer to={`/event/${event.eventPassword}`}><Breadcrumb.Item>{locale('mainMenu.interactive')}</Breadcrumb.Item></LinkContainer>
                        <LinkContainer to={`/event/${event.eventPassword}/interactive/pollsAndVoting`}><Breadcrumb.Item>
                            {locale('mainMenu.interactive.pollsAndVoting')}
                        </Breadcrumb.Item></LinkContainer>
                        <Breadcrumb.Item active>{locale('mainMenu.interactive.managePollResult')}</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <div style={{ padding: "1rem", paddingTop: 0 }}>
                {templates[pollType]({ pollId, event })}
            </div>
        </section>
    );
}

const mapStateToProps = (store) => ({
    event: store.currentEvent
});

export default connect(mapStateToProps)(ManagePollResultPage);